export function joinTemplateString(strings, ...keys) {
    return strings.reduce((acc, str, i) => {
        return acc + str + (keys[i] || '')
    }, '')
}
